import {
  Component,
  EventEmitter,
  Input,
  Output,
  TemplateRef,
  ViewChild
} from '@angular/core';

import { CommonConfirmationModalData } from
  'src/app/components/common/common-confirmation-modal/common-confirmation-modal.component.model';

import { Document } from 'src/app/models';
import { InspectionDocument } from 'src/app/models/inspection-document';

import { TableColumn } from
  'src/app/components/common/common-table/common-table.component';

@Component({
  selector: 'app-inspections-documents',
  standalone: false,
  templateUrl: './documents.component.html',
  styleUrl: './documents.component.scss'
})
export class DocumentsComponent {

  @Input() row: any;
  @Input() documents: InspectionDocument[] = [];

  @Output() added = new EventEmitter<InspectionDocument[]>();
  @Output() deleted = new EventEmitter<string>();
  @Output() saved = new EventEmitter<InspectionDocument>();

  // Added by Vipul on 25-09-2026
  @ViewChild('fileNameTemplate', { static: true })
  fileNameTemplate!: TemplateRef<any>;

  @ViewChild('uploadedOnTemplate', { static: true })
  uploadedOnTemplate!: TemplateRef<any>;

  @ViewChild('uploadedByTemplate', { static: true })
  uploadedByTemplate!: TemplateRef<any>;

  @ViewChild('actionsTemplate', { static: true })
  actionsTemplate!: TemplateRef<any>;
  // End by Vipul on 25-09-2026

  isOpen = true;
  showUploadSection = false;
  editName = '';

  uploadedDocsBatch: Document[] = [];

  confirmationModalData: CommonConfirmationModalData = {
    open: false
  };

  private pendingDeleteId: string | null = null;

  columns: TableColumn[] = [];  // Added by Vipul on 25-09-2026

  get inspectionId(): string {
    return (
      this.row?.id ||
      this.row?.inspectionId ||
      this.row?.inspectionApplicationId ||
      ''
    );
  }

  ngOnInit(): void {
    // Added by Vipul on 25-09-2026
    this.columns = [
      {
        key: 'documentName',
        label: 'File Name',
        headerType: 'text',
        cellType: 'template',
        cellTemplate: this.fileNameTemplate,
        sortable: false,
        hideable: false,
        hideMenu: true
      },
      {
        key: 'createdOn',
        label: 'Uploaded On',
        headerType: 'text',
        cellType: 'template',
        cellTemplate: this.uploadedOnTemplate,
        sortable: false,
        hideable: false,
        hideMenu: true
      },
      {
        key: 'modifiedBy',
        label: 'Uploaded By',
        headerType: 'text',
        cellType: 'template',
        cellTemplate: this.uploadedByTemplate,
        sortable: false,
        hideable: false,
        hideMenu: true
      },
      {
        key: 'actions',
        label: 'Actions',
        headerType: 'text',
        cellType: 'template',
        cellTemplate: this.actionsTemplate,
        sortable: false,
        hideable: false,
        hideMenu: true
      }
    ];
    // End by Vipul on 25-09-2026
  }

  toggleCard(): void {
    this.isOpen = !this.isOpen;
  }

  onUploadClick(): void {
    this.showUploadSection = true;
  }

  onCancelUpload(): void {
    this.showUploadSection = false;
    this.uploadedDocsBatch = [];
  }

  onUploadComplete(uploadedDocs: Document[]): void {
    if (!uploadedDocs || uploadedDocs.length === 0) {
      return;
    }

    this.uploadedDocsBatch = uploadedDocs;
  }

  onSaveUpload(): void {
    if (!this.uploadedDocsBatch.length || !this.inspectionId) {
      return;
    }

    const mappedDocs: InspectionDocument[] =
      this.uploadedDocsBatch.map(d => ({
        id: d.id,
        documentName: d.name,
        inspectionId: this.inspectionId,
        documentPath: d.path,
        createdBy: '',
        createdOn: new Date().toISOString(),
        modifiedBy: '',
        modifiedOn: new Date().toISOString(),
        editing: false
      } as InspectionDocument));

    this.added.emit(mappedDocs);

    this.onCancelUpload();
  }

  deleteDocument(id: string): void {
    this.pendingDeleteId = id;

    this.confirmationModalData = {
      open: true,
      modalDescp: 'Are you sure you want to delete this document?',
      modalSubDescp: 'This action cannot be undone.',
      yesNoBtn: true
    };
  }

  confirmDelete(): void {
    if (!this.pendingDeleteId) {
      return;
    }

    const idToDelete = this.pendingDeleteId;

    this.confirmationModalData.open = false;
    this.pendingDeleteId = null;

    this.deleted.emit(idToDelete);
  }

  cancelDelete(): void {
    this.confirmationModalData.open = false;
    this.pendingDeleteId = null;
  }

  editDocument(doc: InspectionDocument): void {
    this.documents.forEach(d => (d.editing = false));

    this.editName = doc.documentName;
    doc.editing = true;
  }

  cancelEdit(doc: InspectionDocument): void {
    doc.editing = false;
    this.editName = '';
  }

  saveDocument(doc: InspectionDocument): void {
    if (!this.editName.trim()) {
      return;
    }

    doc.documentName = this.editName.trim();
    doc.editing = false;
    this.editName = '';

    this.saved.emit(doc);
  }
}
